import Swiper from 'swiper';
import { EffectFade, Navigation, Scrollbar, Pagination } from 'swiper/modules';
import {
  CAROUSEL_DEFAULT_ARGS,
  CAROUSEL_CLINICAL_WORKS_ARGS,
  CAROUSEL_HERO_MAIN_ARGS,
  CAROUSEL_THERAPIES_ARGS,
  CAROUSEL_CLINICAL_ALLOEGENIC_ARGS,
  CAROUSEL_THERAPIES_WORKS_ARGS,
  CAROUSEL_PUBLICATIONS_ARGS,
  CAROUSEL_THERAPIES_HOW_ARGS
} from '../constants/carousel-args';
import { $mediaStatus } from '../stores/deviceStatus';
import { subscribeKeys } from 'nanostores';

export default class Carousel extends HTMLElement {
  constructor(m) {
    super(m);

    // Binding
    this.onPrefersReducedMotionChange = this.onPrefersReducedMotionChange.bind(this);
    this.onSmallDetectionChange = this.onSmallDetectionChange.bind(this);

    // UI
    this.$swiper = this.querySelector('[data-swiper]');
    this.$parent = this.closest('[data-carousel-parent]');
    this.$prevButton = this.$parent?.querySelector('[data-swiper-prev]');
    this.$nextButton = this.$parent?.querySelector('[data-swiper-next]');
    this.$scrollbar = this.$parent?.querySelector('[data-carousel-progress]');
    // Data
    this.swiper = null;
    this.type = this.dataset.type;
  }

  // =============================================================================
  // Lifecycle methods
  // =============================================================================
  connectedCallback() {
    this.unbindPrefersReducedMotion = subscribeKeys(
      $mediaStatus,
      ['isReducedMotion'],
      this.onPrefersReducedMotionChange
    );

    this.unbindSmallDetection = subscribeKeys(
      $mediaStatus,
      ['isSmall'],
      this.onSmallDetectionChange
    );
  }

  disconnectedCallback() {
    this.destroySwiper();
    this.unbindPrefersReducedMotion?.();
    this.onSmallDetectionChange?.();
  }

  // =============================================================================
  // Callbacks
  // =============================================================================
  onPrefersReducedMotionChange() {
    if (this.type === 'listing-gallery' && !$mediaStatus.get().isSmall) return;
    this.destroySwiper();
    this.initSwiper();
  }

  onSmallDetectionChange() {
    if (
      this.type === 'listing-gallery' &&
      $mediaStatus.get().isSmall &&
      !$mediaStatus.get().isReducedMotion
    ) {
      this.initSwiper();
    } else if (this.type === 'listing-gallery' && !$mediaStatus.get().isSmall) {
      this.destroySwiper();
    }
  }

  // =============================================================================
  // Methods
  // =============================================================================
  initSwiper() {
    let argsFunction;
    let modules;

    switch (this.type) {
      // case 'listing-gallery':
      //   argsFunction = CAROUSEL_LISTING_GALLERY_ARGS;
      //   break;

      case 'therapies':
        argsFunction = CAROUSEL_THERAPIES_ARGS;
        modules = [Navigation];
        break;

      case 'clinical-works':
        argsFunction = CAROUSEL_CLINICAL_WORKS_ARGS;
        modules = [Navigation];
        break;

      case 'clinical-allogeneic':
        argsFunction = CAROUSEL_CLINICAL_ALLOEGENIC_ARGS;
        modules = [Scrollbar];
        break;

      case 'therapies-works':
        argsFunction = CAROUSEL_THERAPIES_WORKS_ARGS;
        modules = [Scrollbar];
        break;

      case 'hero-main':
        argsFunction = CAROUSEL_HERO_MAIN_ARGS;
        modules = [Navigation, EffectFade, Scrollbar, Pagination];
        break;

      case 'therapies-how':
        argsFunction = CAROUSEL_THERAPIES_HOW_ARGS;
        modules = [Scrollbar];
        break;

      case 'publications':
        argsFunction = CAROUSEL_PUBLICATIONS_ARGS;
        modules = [Navigation, Scrollbar];
        break;

      default:
        argsFunction = CAROUSEL_DEFAULT_ARGS;
        modules = [Navigation];
        break;
    }

    const args = argsFunction({
      modules,
      $swiper: this,
      $prevButton: this.$prevButton,
      $nextButton: this.$nextButton,
      $scrollbar: this.$scrollbar,
      isPrefersReducedMotion: $mediaStatus.get().isReducedMotion
    });

    this.swiper = new Swiper(this.$swiper, { init: false, ...args });
    this.swiper.autoplay?.pause();
    this.swiper.init();
  }

  destroySwiper() {
    this.swiper?.destroy(true, true);
  }
}
